import { Module, ActionContext } from 'vuex';
import { ajax } from '@/util/ajax';
import {catalogModule as catalog} from '@/store/experiment/catalogModule';
import {expModule as exp} from '@/store/experiment/expModule';

const URL = {
  VERSION_LIST: '/dh-datamaint/version/listAll',
  SUBMIT_VERSION: '/dh-datamaint/version/submit',
  VERSION_LIST_SELF: '/dh-datamaint/version/listSelf'
};

class ExperimentModule implements Module<any, any> {
  namespaced = true;

  state = {};

  mutations = {};

  actions = {
    async getVersionList(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.VERSION_LIST, { params: payload.data });
    },

    async getVersionListSelf(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.VERSION_LIST_SELF, { params: payload.data });
    },

    async submitVersion(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.SUBMIT_VERSION, payload.data);
    }
  };

  modules = {
    catalog,
    exp
  };
}

export const experimentModule = new ExperimentModule();
